module.exports = __webpack_public_path__ + "img/news.066185df.png";